<cc-progress-bar [isLoading]="isLoading$ | async"></cc-progress-bar>
@if (isYearsMissing$ | async) {
  <div class="flex flex-col items-center justify-center">
    <div class="text-center !text-red-700 text-base font-semibold">
      Konfiguration erforderlich
    </div>
  
    <div class="text-center !text-red-700 text-base">
      Für dieses HKN-Kunden-Widget wurden noch keine Lieferjahre konfiguriert.
    </div>
  
  </div>
} @else if (viewModel$ | async; as vm) {
  <div class="flex min-h-0 flex-1 flex-col">
    <div class="min-h-0 flex-1 overflow-auto">
      <table class="min-w-full divide-y divide-gray-200 table-layout">
        <thead>
          <tr>
            <th scope="col" class="text-left">
              {{ 'master-data.COMPANY' | transloco }}
            </th>
            <th scope="col" class="text-left">
              Lieferjahr
            </th>
            <th scope="col" class="text-right">
              {{ 'master-data.HKN_CERTIFICATE' | transloco }}
            </th>
            <th scope="col" class="w-10"></th>
            <th scope="col" class="text-right">
              {{ 'master-data.CLOSED' | transloco }} (MWh)
            </th>
            <th scope="col" class="text-right">
              {{ 'master-data.CONTRACT_AMOUNT' | transloco }} (MWh)
            </th>
            <th scope="col" class="text-right">
              {{ 'master-data.LONG_SHORT_MWH' | transloco }}
            </th>
          </tr>
        </thead>
        <tbody>
          @for (customer of vm.customers; track customer.id) {
            <!-- Main row: customer totals -->
            <tr class="border-b border-gray-200">
              @if (config?.filter?.energySource; as energySource) {
                <td
                  class="text-sm font-medium align-top whitespace-nowrap text-primary-color hover:text-black hover:bg-gray-100 hover:cursor-pointer"
                  [routerLink]="[
                    '/company-' +
                      energySource.toLowerCase() +
                      '/' +
                      customer.id +
                      '/' +
                      energySource.toLowerCase() +
                      '/orders/hkn/orders',
                  ]"
                >
                  {{ customer.name }}
                </td>
              } @else {
                <td class="text-sm font-medium align-top whitespace-nowrap">
                  {{ customer.name }}
                </td>
              }
              <td class="align-top"></td>
              <td class="align-top"></td>
              <td class="align-top w-10">
                @if (customer.valuesByYear?.length) {
                  <button
                    type="button"
                    class="h-8 w-8 rounded-full hover:bg-gray-300 flex items-center justify-center"
                    (click)="toggleExpanded(customer.id); $event.stopPropagation()"
                    [attr.aria-label]="
                      isExpanded(customer.id) ? 'Collapse' : 'Expand'
                    "
                  >
                    <fa-icon
                      [icon]="
                        isExpanded(customer.id) ? faChevronUp : faChevronDown
                      "
                      class="fa-spacer"
                    ></fa-icon>
                  </button>
                }
              </td>
              <td class="text-sm text-right align-top whitespace-nowrap">
                {{ getTotalClosed(customer) | number: '1.2-2' }}
              </td>
              <td
                class="text-sm font-medium text-right align-top whitespace-nowrap"
                global-tooltip="{{
                  (getCustomerTotalAmount(customer) | number: '.2-2') + ' GWh'
                }}"
              >
                {{ getTotalContractAmount(customer) | number: '1.2-2' }}
              </td>
              <td class="text-sm text-right align-top whitespace-nowrap">
                {{ getTotalOpen(customer) | number: '1.2-2' }}
              </td>
            </tr>
            <!-- Year rows (when customer expanded) -->
            @if (isExpanded(customer.id)) {
              @for (year of customer.valuesByYear; track year.deliveryYear) {
                <tr class="border-b border-gray-100 bg-gray-50/50">
                  <td class="pl-6 text-sm text-gray-600 align-top"></td>
                  <td class="text-sm font-medium align-top">
                    {{ year.deliveryYear }}
                  </td>
                  <td class="align-top"></td>
                  <td class="align-top w-10">
                    @if (year.positionValuesByType?.length) {
                      <button
                        type="button"
                        class="h-8 w-8 rounded-full hover:bg-gray-300 flex items-center justify-center"
                        (click)="toggleYearExpanded(customer.id, year.deliveryYear); $event.stopPropagation()"
                        [attr.aria-label]="
                          isYearExpanded(customer.id, year.deliveryYear) ? 'Collapse' : 'Expand'
                        "
                      >
                        <fa-icon
                          [icon]="
                            isYearExpanded(customer.id, year.deliveryYear) ? faChevronUp : faChevronDown
                          "
                          class="fa-spacer"
                        ></fa-icon>
                      </button>
                    }
                  </td>
                  <td class="text-sm text-right align-top whitespace-nowrap">
                    {{ getYearTotalClosed(year) | number: '1.2-2' }}
                  </td>
                  <td
                    class="text-sm text-right align-top whitespace-nowrap"
                    global-tooltip="{{
                      (year.totalAmount | number: '.2-2') + ' GWh'
                    }}"
                  >
                    {{ getYearTotalContractAmount(year) | number: '1.2-2' }}
                  </td>
                  <td class="text-sm text-right align-top whitespace-nowrap">
                    {{ getYearTotalOpen(year) | number: '1.2-2' }}
                  </td>
                </tr>
                <!-- HKN type rows (when year expanded) -->
                @if (isYearExpanded(customer.id, year.deliveryYear)) {
                  @for (pv of year.positionValuesByType; track pv.key) {
                    <tr class="border-b border-gray-100 bg-gray-100/50">
                      <td class="pl-12 text-sm text-gray-600 align-top"></td>
                      <td class="align-top"></td>
                      <td class="text-right align-top">
                        <span
                          class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold bg-gray-200 text-gray-700 dark:bg-layout-dark-input dark:text-layout-dark-page-container-text"
                        >
                          {{ pv.key }}
                        </span>
                      </td>
                      <td class="align-top w-10"></td>
                      <td class="text-sm text-right align-top whitespace-nowrap">
                        {{ pv.value.closedAmount | number: '1.2-2' }}
                      </td>
                      <td class="text-sm text-right align-top whitespace-nowrap">
                        {{ pv.value.contractAmount | number: '1.2-2' }}
                      </td>
                      <td class="text-sm text-right align-top whitespace-nowrap">
                        {{ pv.value.openAmount | number: '1.2-2' }}
                      </td>
                    </tr>
                  }
                }
              }
            }
          }
          <!-- Sum row over all customers (optional via widget config) -->
          @if (config?.showSumRow && vm.customers?.length) {
            <tr class="border-t-2 border-gray-300">
              <td class="text-sm font-semibold align-top whitespace-nowrap">
                {{ 'market-hkn-customers.SUM' | transloco }}
              </td>
              <td class="align-top"></td>
              <td class="align-top"></td>
              <td class="align-top w-10"></td>
              <td class="text-sm font-semibold text-right align-top whitespace-nowrap">
                {{ getGrandTotalClosed(vm.customers) | number: '1.2-2' }}
              </td>
              <td
                class="text-sm font-semibold text-right align-top whitespace-nowrap"
                global-tooltip="{{
                  (getGrandTotalAmount(vm.customers) | number: '.2-2') + ' GWh'
                }}"
              >
                {{ getGrandTotalContractAmount(vm.customers) | number: '1.2-2' }}
              </td>
              <td class="text-sm font-semibold text-right align-top whitespace-nowrap">
                {{ getGrandTotalOpen(vm.customers) | number: '1.2-2' }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (hasAppliedFilters(vm.appliedFilters)) {
      <aside
        class="shrink-0 border-t border-gray-200 bg-white px-3 py-1.5 dark:border-layout-dark-border dark:bg-layout-dark-card"
      >
        <p
          class="m-0 text-[10px] font-semibold uppercase leading-tight tracking-wide text-gray-500 dark:text-layout-dark-title-color"
        >
          {{ 'market-hkn-customers.APPLIED_FILTERS' | transloco }}
        </p>

        <dl
          class="m-0 mt-0.5 flex max-h-[4.5rem] flex-wrap items-baseline gap-x-3.5 gap-y-0.5 overflow-y-auto"
        >
          @if (hasTextValue(vm.appliedFilters.marketAreaName)) {
            <div
              class="inline-flex min-w-0 max-w-full items-baseline gap-1 text-xs leading-tight"
            >
              <dt class="m-0 shrink-0 font-medium text-gray-500 dark:text-layout-dark-title-color">
                {{ 'market-hkn-customers.MARKET_AREA' | transloco }}:
              </dt>
              <dd class="m-0 min-w-0 break-words text-gray-900 dark:text-layout-dark-page-container-text">
                {{ vm.appliedFilters.marketAreaName }}
              </dd>
            </div>
          }

          @if (hasTextValue(vm.appliedFilters.deliveryAreaName)) {
            <div
              class="inline-flex min-w-0 max-w-full items-baseline gap-1 text-xs leading-tight"
            >
              <dt class="m-0 shrink-0 font-medium text-gray-500 dark:text-layout-dark-title-color">
                {{ 'market-hkn-customers.DELIVERY_AREA' | transloco }}:
              </dt>
              <dd class="m-0 min-w-0 break-words text-gray-900 dark:text-layout-dark-page-container-text">
                {{ vm.appliedFilters.deliveryAreaName }}
              </dd>
            </div>
          }

          @if (hasTextValue(vm.appliedFilters.segmentName)) {
            <div
              class="inline-flex min-w-0 max-w-full items-baseline gap-1 text-xs leading-tight"
            >
              <dt class="m-0 shrink-0 font-medium text-gray-500 dark:text-layout-dark-title-color">
                {{ 'master-data.SEGMENT' | transloco }}:
              </dt>
              <dd class="m-0 min-w-0 break-words text-gray-900 dark:text-layout-dark-page-container-text">
                {{ vm.appliedFilters.segmentName }}
              </dd>
            </div>
          }

          @if (hasListValue(vm.appliedFilters.kamNames)) {
            <div
              class="inline-flex min-w-0 max-w-full items-baseline gap-1 text-xs leading-tight"
            >
              <dt class="m-0 shrink-0 font-medium text-gray-500 dark:text-layout-dark-title-color">
                {{ 'market-hkn-customers.KAMS' | transloco }}:
              </dt>
              <dd class="m-0 min-w-0 break-words text-gray-900 dark:text-layout-dark-page-container-text">
                {{ joinValues(vm.appliedFilters.kamNames) }}
              </dd>
            </div>
          }

          @if (hasListValue(vm.appliedFilters.companyNames)) {
            <div
              class="inline-flex min-w-0 max-w-full items-baseline gap-1 text-xs leading-tight"
            >
              <dt class="m-0 shrink-0 font-medium text-gray-500 dark:text-layout-dark-title-color">
                {{ 'bo.common.COMPANIES' | transloco }}:
              </dt>
              <dd class="m-0 min-w-0 break-words text-gray-900 dark:text-layout-dark-page-container-text">
                {{ joinValues(vm.appliedFilters.companyNames) }}
              </dd>
            </div>
          }

          @if (hasListValue(vm.appliedFilters.hknTypeNames)) {
            <div
              class="inline-flex min-w-0 max-w-full items-baseline gap-1 text-xs leading-tight"
            >
              <dt class="m-0 shrink-0 font-medium text-gray-500 dark:text-layout-dark-title-color">
                {{ 'master-data.HKN_CERTIFICATE' | transloco }}:
              </dt>
              <dd class="m-0 min-w-0 break-words text-gray-900 dark:text-layout-dark-page-container-text">
                {{ joinValues(vm.appliedFilters.hknTypeNames) }}
              </dd>
            </div>
          }

          @if (hasListValue(vm.appliedFilters.years)) {
            <div
              class="inline-flex min-w-0 max-w-full items-baseline gap-1 text-xs leading-tight"
            >
              <dt class="m-0 shrink-0 font-medium text-gray-500 dark:text-layout-dark-title-color">
                {{ 'master-data.YEARS' | transloco }}:
              </dt>
              <dd class="m-0 min-w-0 break-words text-gray-900 dark:text-layout-dark-page-container-text">
                {{ joinValues(vm.appliedFilters.years) }}
              </dd>
            </div>
          }

          @if (hasTradeDateRange(vm.appliedFilters)) {
            <div
              class="inline-flex min-w-0 max-w-full items-baseline gap-1 text-xs leading-tight"
            >
              <dt class="m-0 shrink-0 font-medium text-gray-500 dark:text-layout-dark-title-color">
                {{ 'market-hkn-customers.TRADE_DATE_RANGE' | transloco }}:
              </dt>
              <dd class="m-0 min-w-0 break-words text-gray-900 dark:text-layout-dark-page-container-text">
                @if (
                  hasDateValue(vm.appliedFilters.tradeDateFrom) &&
                  hasDateValue(vm.appliedFilters.tradeDateTo)
                ) {
                  {{ vm.appliedFilters.tradeDateFrom | date: 'shortDate' }}
                  -
                  {{ vm.appliedFilters.tradeDateTo | date: 'shortDate' }}
                } @else if (hasDateValue(vm.appliedFilters.tradeDateFrom)) {
                  {{ 'bo.common.FROM' | transloco }}
                  {{ vm.appliedFilters.tradeDateFrom | date: 'shortDate' }}
                } @else if (hasDateValue(vm.appliedFilters.tradeDateTo)) {
                  {{ 'bo.common.TO' | transloco }}
                  {{ vm.appliedFilters.tradeDateTo | date: 'shortDate' }}
                }
              </dd>
            </div>
          }
        </dl>
      </aside>
    }
  </div>
}
